import { render, staticRenderFns } from "./picZoom.vue?vue&type=template&id=049ec1ba&scoped=true"
import script from "./picZoom.vue?vue&type=script&lang=js"
export * from "./picZoom.vue?vue&type=script&lang=js"
import style0 from "./picZoom.vue?vue&type=style&index=0&id=049ec1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049ec1ba",
  null
  
)

export default component.exports